import { Badge, cn } from '@rematter/ui-web';
import { ThemeColor } from '@rematter/ui-web/types';

import { UserStatus } from './types';

import { useTranslations } from '~/modules/settings/i18n/useTranslations';

export type { UserStatus };

export type UserStatusBadgeProps = {
  status: UserStatus;
  size?: 'xs' | 'small' | 'default' | 'large';
  className?: string;
};

const statusColors: Record<UserStatus, ThemeColor> = {
  active: 'success',
  archived: 'failure',
  invite_sent: 'neutral',
};

export const UserStatusBadge: React.FC<UserStatusBadgeProps> = ({
  status,
  size = 'small',
  className,
}) => {
  const t = useTranslations();

  const labelMap: Record<UserStatus, string> = {
    active: t.teamAndPermissions.userStatus.active,
    archived: t.teamAndPermissions.userStatus.archived,
    invite_sent: t.teamAndPermissions.userStatus.inviteSent,
  };

  return (
    <Badge
      color={statusColors[status]}
      size={size}
      className={cn('@UserStatusBadge', className)}
    >
      {labelMap[status]}
    </Badge>
  );
};
